export const FREEMIUM_PRIORITY_LEVEL = 0
export const LIGHT_PRIORITY_LEVEL = 1
export const PRO_PRIORITY_LEVEL = 2
export const DIGIFARMZ_PRIORITY_LEVEL = 3
export const FULL_PRIORITY_LEVEL = 4
